"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocsTooltipContentSkeletonLoader = DocsTooltipContentSkeletonLoader;
var _react = _interopRequireDefault(require("react"));
var _lab = require("@material-ui/lab");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function DocsTooltipContentSkeletonLoader() {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text",
    width: 480,
    height: 24,
    animation: "wave"
  }), /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text",
    width: 480,
    height: 24,
    animation: "wave"
  }), /*#__PURE__*/_react.default.createElement(_lab.Skeleton, {
    variant: "text",
    width: 480,
    height: 24,
    animation: "wave"
  }));
}